module.exports = __webpack_public_path__ + "img/23-FCP-additional-recources.39339c72.svg";